import { ThemeType } from "src/library/utils";

// Helper to get a different stroke colour based on lines mapped iteration
export const getStroke = (iteration: number, theme: ThemeType) => {
  switch (iteration) {
    case 0:
      return "#2196F3"; // blue
    case 1:
      return "#FF5722"; // deep orange
    case 2:
      return "#4CAF50"; // green
    case 3:
      return "#9C27B0"; // purple
    case 4:
      return "#FFC107"; // amber
    case 5:
      return "#3F51B5"; // indigo
    case 6:
      return "#F44336"; // red
    case 7:
      return "#00BCD4"; // cyan
    case 8:
      return "#E91E63"; // pink
    case 9:
      return "#607D8B"; // blue grey
    case 10:
      return "#795548"; // brown
    case 11:
      return "#8BC34A"; // light green
    case 12:
      return "#FF9800"; // orange
    case 13:
      return "#FFEB3B"; // yellow
    case 14:
      return "#9E9E9E"; // grey
    case 15:
      return "#00ACC1"; // teal
    case 16:
      return "#E57373"; // light Red
    case 17:
      return "#9FA8DA"; // lght Indigo
    case 18:
      return "#FFD54F"; // amber
    case 19:
      return "#64B5F6"; // light blue
    case 20:
      return "#C5E1A5"; // light green 2
    case 21:
      return "#A1887F"; // grey 2
    case 22:
      return "#DCE775"; // lime
    case 23:
      return "#4DD0E1"; // cyan 2
    case 24:
      return "#F48FB1"; // rose
    case 25:
      return "#81C784"; // light green 3
    case 26:
      return "#90A4AE"; // blue grey 2
    case 27:
      return "#FFAB91"; // pink 2
    case 28:
      return "#D7CCC8"; // brown 2
    case 29:
      return "#4DB6AC"; // turquoise
    case 30:
      return "#FFAB00"; // topaz
    default:
      return theme.colors.primaryDark;
  }
};